export class UpdateBillingRule {

    billingRule;
    constructor(billingRule) {
      this.billingRule = billingRule;
    }
  };
  